import { t } from 'i18next';
import { ExternalLink } from '../external-link/external-link.spark';
import { Icon } from '../icon/icon.spark';
import type { LearnMoreLinkProps } from './types';

export function LearnMoreLink({ link }: LearnMoreLinkProps) {
  return (
    <ExternalLink link={link}>
      <span>{t('links:learn_more')}</span>
      <Icon name="externalLink" />
    </ExternalLink>
  );
}
